module.exports = {"653222100":"喀拉喀什镇","653222101":"扎瓦镇","653222102":"奎牙镇","653222103":"喀尔赛镇","653222203":"阿克萨拉依乡","653222204":"乌尔其乡","653222205":"托胡拉乡","653222206":"萨依巴格乡","653222207":"加汗巴格乡","653222208":"普恰克其乡","653222209":"芒来乡","653222210":"阔依其乡","653222211":"雅瓦乡","653222212":"吐外特乡","653222213":"英也尔乡","653222214":"喀瓦克乡","653222500":"兵团四十七团","653222501":"兵团二二四团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/653222.json
// module id = 2902
// module chunks = 0